import find from 'lodash/find';
var _fileTypes = [{
  expr: /(xlsx?|numbers)/i,
  color: '#70c79a',
  type: 'table'
}, {
  expr: /(png|jpe?g|tiff|gif)/i,
  color: '#40a0f4',
  type: 'image'
}, {
  expr: /(js|cs|java|md|c|py|ts)/i,
  color: '#999',
  type: 'code'
}, {
  expr: /(pptx?|key)/i,
  color: '#FF5252',
  type: 'slides'
}, {
  expr: /.*/,
  color: '#FF5252',
  type: 'text'
}];
export var iconType = function iconType() {
  var fileType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return find(_fileTypes, function (opts) {
    return fileType.match(opts.expr);
  }) || _fileTypes[_fileTypes.length - 1];
};
//# sourceMappingURL=iconUtil.js.map
